import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ManageCampaignService {

  constructor(private api: ApiService) { }

  getAllManangeCampaign(data:any): Observable<any> {
    return this.api.post(environment.getAllManangeCampaign,data);
  }

  getAllWhatsappTemplatesGupshup(data:any): Observable<any> {
    return this.api.post(environment.getAllWhatsappTemplatesGupshup,data);
  }

  getAllEmailTemplates(data:any): Observable<any> {
    return this.api.post(environment.getAllEmailTemplates,data);
  }

  getAllContactGroups(data:any): Observable<any> {
    return this.api.post(environment.getAllContactGroups,data);
  }

  createCampaign(data:any): Observable<any> {
    return this.api.post(environment.createCampaign,data);
  }

  updateCampaign(data:any): Observable<any> {
    return this.api.post(environment.updateCampaign,data);
  }
  


  runCampaign(data:any): Observable<any> {
    return this.api.post(environment.runCampaign,data);
  }

  deleteCampaign(data:any): Observable<any> {
    return this.api.post(environment.deleteCampaign,data);
  }

  getTemplateById(data:any): Observable<any> {
    return this.api.post(environment.getGupshuTemplateById,data);
  }

  getEmailTemplateById(data:any): Observable<any> {
    return this.api.post(environment.getEmailTemplateById,data);
  }

  getAllTemplatesWithStatusFilter(data:any): Observable<any> {
    return this.api.post(environment.getAllTemplatesWithStatusFilter,data);
  }

  testCampaignEmail(data:any): Observable<any> {
    return this.api.post(environment.testCampaignEmail,data);
  }

  testCampaignWhatsapp(data:any): Observable<any> {
    return this.api.post(environment.testCampaignWhatsapp,data);
  }

}


